<script lang="ts">
    import { createEventDispatcher } from 'svelte/internal'
    import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
    import { navigateTo } from 'yrv'
    import ObStep from './ob-step.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    const dispatch = createEventDispatcher()

    function onNext() {
        dispatch('next')
    }

    function onAbort() {
        if (!confirm('Recomendamos que conclua o onboard. Deseja mesmo abandonar?')) {
            return
        }
        navigateTo('/agenda/all')
    }

    async function onNever() {
        if (!confirm('Recomendamos que conclua o onboard. Deseja mesmo abandonar?')) {
            return
        }
        await window.flags('onboarding', false, true)
        navigateTo('/agenda/all')
    }
</script>

<ObStep title="Bem vindo ao Zandu!" label="Experiência de ponta a ponta.">
    <svelte:fragment slot="acts">
        <Zbutton color="secondary" label="Não exibir novamente" on:click={onNever} />
        <Zbutton color="secondary" label="Deixar para depois" on:click={onAbort} />
        <Zbutton color="primary" icon={faAngleRight} label="Avançar" on:click={onNext} />
    </svelte:fragment>

    <h4>Precisamos saber de quantas agendas você precisa, além de outras poucas informações.</h4>
    <p>Para isso clique em "Avançar"</p>
    <p class="mb-1 text-warning">Você pode abandonar o onboarding, mas o Zandu não estará pronto para ser usado.</p>
</ObStep>
